const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagHongKong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 12,
    style: {
      fill: "rgb(93.333333%,10.980392%,14.509804%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.859375 2.503906 C 9.691406 2.558594 9.5625 2.683594 9.503906 2.847656 C 9.445312 3.011719 9.464844 3.195312 9.5625 3.339844 C 9.707031 3.5625 9.746094 3.839844 9.667969 4.097656 C 9.589844 4.351562 9.402344 4.558594 9.15625 4.664062 C 8.910156 4.765625 8.738281 4.988281 8.695312 5.246094 C 8.648438 5.507812 8.742188 5.773438 8.9375 5.949219 C 8.335938 5.519531 8.183594 4.6875 8.597656 4.070312 C 8.589844 4.066406 8.582031 4.058594 8.574219 4.050781 C 8.152344 4.675781 8.300781 5.523438 8.910156 5.964844 C 8.058594 5.625 7.597656 4.699219 7.839844 3.8125 C 8.082031 2.925781 8.949219 2.363281 9.859375 2.503906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,10.980392%,14.509804%)",
      fillOpacity: 1
    },
    d: "M 9.039062 3.621094 L 8.488281 3.863281 L 9.074219 3.992188 L 8.675781 3.542969 L 8.734375 4.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.589844 5.738281 C 12.488281 5.59375 12.328125 5.507812 12.152344 5.503906 C 11.980469 5.5 11.8125 5.574219 11.703125 5.710938 C 11.535156 5.917969 11.285156 6.042969 11.015625 6.046875 C 10.75 6.050781 10.492188 5.9375 10.320312 5.734375 C 10.144531 5.535156 9.882812 5.4375 9.621094 5.476562 C 9.359375 5.515625 9.136719 5.683594 9.027344 5.925781 C 9.25 5.21875 9.996094 4.816406 10.710938 5.019531 C 10.714844 5.011719 10.71875 5.003906 10.722656 4.992188 C 9.996094 4.785156 9.238281 5.1875 9.003906 5.902344 C 9.066406 4.988281 9.804688 4.261719 10.722656 4.21875 C 11.640625 4.175781 12.445312 4.828125 12.589844 5.738281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,10.980392%,14.509804%)",
      fillOpacity: 1
    },
    d: "M 11.273438 5.304688 L 10.875 4.851562 L 10.933594 5.453125 L 11.238281 4.933594 L 10.6875 5.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.25 8.324219 C 6.414062 8.378906 6.597656 8.351562 6.742188 8.253906 C 6.882812 8.15625 6.972656 7.996094 6.984375 7.824219 C 6.996094 7.554688 7.128906 7.308594 7.339844 7.148438 C 7.554688 6.988281 7.828125 6.929688 8.089844 6.988281 C 8.347656 7.050781 8.617188 6.972656 8.804688 6.789062 C 8.996094 6.605469 9.074219 6.335938 9.019531 6.078125 C 9.257812 6.78125 8.890625 7.542969 8.191406 7.796875 C 8.195312 7.804688 8.195312 7.816406 8.199219 7.828125 C 8.90625 7.570312 9.285156 6.796875 9.054688 6.078125 C 9.542969 6.855469 9.371094 7.878906 8.652344 8.453125 C 7.9375 9.027344 6.902344 8.972656 6.25 8.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,10.980392%,14.509804%)",
      fillOpacity: 1
    },
    d: "M 7.570312 7.902344 L 8.15625 8.03125 L 7.757812 7.582031 L 7.816406 8.179688 L 8.121094 7.660156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.359375 9.332031 C 10.464844 9.191406 10.496094 9.011719 10.445312 8.84375 C 10.398438 8.679688 10.273438 8.542969 10.109375 8.480469 C 9.859375 8.386719 9.667969 8.183594 9.578125 7.933594 C 9.492188 7.679688 9.523438 7.402344 9.660156 7.171875 C 9.796875 6.945312 9.808594 6.664062 9.691406 6.429688 C 9.574219 6.191406 9.34375 6.03125 9.078125 6.003906 C 9.820312 5.996094 10.433594 6.582031 10.460938 7.324219 C 10.46875 7.324219 10.480469 7.324219 10.488281 7.328125 C 10.464844 6.574219 9.847656 5.972656 9.09375 5.972656 C 9.984375 5.75 10.902344 6.226562 11.226562 7.085938 C 11.550781 7.949219 11.175781 8.914062 10.359375 9.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,10.980392%,14.509804%)",
      fillOpacity: 1
    },
    d: "M 10.367188 7.945312 L 10.671875 7.429688 L 10.117188 7.667969 L 10.707031 7.796875 L 10.308594 7.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.941406 4.101562 C 5.941406 4.277344 6.019531 4.441406 6.15625 4.546875 C 6.296875 4.652344 6.476562 4.691406 6.644531 4.644531 C 6.902344 4.574219 7.175781 4.625 7.394531 4.777344 C 7.613281 4.929688 7.753906 5.171875 7.777344 5.441406 C 7.800781 5.703125 7.957031 5.9375 8.191406 6.058594 C 8.425781 6.179688 8.703125 6.175781 8.933594 6.042969 C 8.339844 6.484375 7.5 6.371094 7.042969 5.789062 C 7.03125 5.792969 7.023438 5.796875 7.015625 5.800781 C 7.476562 6.398438 8.332031 6.519531 8.941406 6.074219 C 8.351562 6.78125 7.328125 6.933594 6.558594 6.429688 C 5.792969 5.921875 5.527344 4.921875 5.941406 4.101562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,10.980392%,14.509804%)",
      fillOpacity: 1
    },
    d: "M 6.75 5.226562 L 6.808594 5.824219 L 7.113281 5.308594 L 6.5625 5.546875 L 7.148438 5.675781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHongKong);
export default __webpack_public_path__ + "static/media/flag-hong-kong.28b39ef23e9410f670e56c7a40820d5a.svg";
export { ForwardRef as ReactComponent };